import  { useEffect, useState } from "react";
import axios from "axios";
import { showToast } from "../Buttons/Toaster";
import "../../components/CSSCustom/toaster.css";
import CustomTooltip from "../Buttons/CustomTooltip";

function Edit({ show, setShow, job, onSave, apiEndpoint ,type = "job"}) {
  const [jobName, setJobName] = useState(job?.job_name || job?.job_name || "");
  const [jobDescription, setJobDescription] = useState(job?.job_description || job?.migration_description || "");
 
  const [jobNameError, setJobNameError] = useState("");
  const [duplicateJobError, setDuplicateJobError] = useState(null);

  const MAX_DESCRIPTION_LENGTH = 500;

  // Determine labels based on API endpoint
const nameLabel = type === "migration" ? "Migration Name" : "Job Name";
const descriptionLabel = type === "migration" ? "Migration Description" : "Job Description";


  const validateJobName = (name) => {
    return /^[a-zA-Z0-9 ]+$/.test(name);
  };
 // Reset form when modal opens or job changes
  useEffect(() => {
    if (show && job) {
      setJobName(job.job_name || "")
      setJobDescription(job.description || "")
      setJobNameError("")
      setDuplicateJobError(null)
    }
  }, [show, job]) // Added 'show' to dependencies
    useEffect(() => {
    if (!show) {
      setJobNameError("")
      setDuplicateJobError(null)
    }
  }, [show])

    const showScopedToast = (message, type = "success", options = {}) => {
    const prefix = type === "migration" ? "migration" : "source-profiler";
    const defaultOptions = {
      toastId: `${prefix}-edit-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    };
    return showToast(message, type, { ...defaultOptions, ...options });
  };

  const handleJobNameChange = (e) => {
    const value = e.target.value;
    if (value === "" || validateJobName(value)) {
      setJobName(value);
      setJobNameError("");
    } else {
      setJobNameError("Only letters, numbers, and spaces are allowed.");
    }
  };

  const handleJobDescriptionChange = (e) => {
    const value = e.target.value;
    setJobDescription(value.slice(0, MAX_DESCRIPTION_LENGTH));
  };

   const handleSave = async () => {
    if (!jobName.trim()) {
      showScopedToast(`${nameLabel} cannot be empty.`, "error");
      return;
    }

    if (!validateJobName(jobName.trim())) {
      showScopedToast(`${nameLabel} contains invalid characters.`, "error");
      return;
    }

    if (!job) {
      showScopedToast("No item selected for editing.", "error");
      setShow(false);
      return;
    }

    const isNameChanged = 
      jobName.trim() !== (job.job_name || job.job_name || "");
    const isDescriptionChanged = 
      jobDescription.trim() !== (job.job_description || job.migration_description || "");

    if (!isNameChanged && !isDescriptionChanged) {
      showScopedToast("No changes were made to the job name and description.", "success");
      setShow(false);
      return;
    }

    try {
      const authToken = sessionStorage.getItem("access_token");
      if (!authToken) {
        throw new Error("Authentication token missing.");
      }

      const url = new URL(apiEndpoint);
      url.searchParams.append("job_id", job.job_id || job.id);

      const updatedFields = [];
      if (jobName.trim() && jobName.trim() !== job.job_name) {
        url.searchParams.append("job_name", jobName.trim());
        updatedFields.push(nameLabel);
      }
      if (jobDescription.trim() && jobDescription.trim() !== job.description) {
        url.searchParams.append("job_description", jobDescription.trim());
        updatedFields.push(descriptionLabel);
      }

      if (updatedFields.length === 0) {
        showScopedToast("No changes were made in the job name and job description.", "success");
        setShow(false);
        return;
      }

      const response = await axios.put(url.toString(), null, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      const successMessage = `${updatedFields.join(" and ")} updated successfully!`;
      showScopedToast(successMessage, "success");

      onSave();
      setShow(false);
    } catch (error) {
      console.error("Update failed:", error);
      showScopedToast(
        `Error: ${error.response?.data?.detail || error.message || "Failed to update item."}`,
        "error"
      );
      setShow(false);
    }
  };
 const handleClose = () => {
    // Reset form to original values when closing
    if (job) {
      setJobName(job.job_name || "")
      setJobDescription(job.description || "")
    }
    setJobNameError("")
    setDuplicateJobError(null)
    setShow(false)
  }

  return (
    <div>
      <div className={`right-baredit p-3 ${show ? "d-block" : "d-none"}`} style={{ width: "auto" }}>

        <div>
          <div className="d-flex align-items-center justify-content-between">
            <h6 className=" font-size-13 mb-0 fw-medium text-dark">
              Edit {type === "migration" ? "Migration" : "Job"}
            </h6>
           <CustomTooltip content="Close" placement="left" fallbackPlacements={['bottom']}>
  <i
    onClick= {handleClose} 
    className="mdi mdi-close close-trace cursor-pointer right-bar-toggle3 iconColor"
  />
</CustomTooltip>
          </div>
           <div className="trace-label  mt-1 pe-3 d-flex align-items-center mb-3 w-fit-content">
          <img
           src="/assets/images/trace_label.png"
            className="w-14px me-2"
            alt="Job icon"
          />
          
             <span style={{ color: "black", fontSize: "12px" }}>
              Make changes to your existing  {" "}
              {type === "migration" ? "migration" : "job"}
            </span>
          
        </div>

          <h6 className=" fw-sbold font-size-12 mt-3">{nameLabel}</h6>
          <input
            type="text"
            className={`form-control highlighted-input font-size-12 doc-search  colorfor-placeholder styled-input ${
              duplicateJobError || jobNameError ? "is-invalid" : ""
            }`}
            style={jobNameError ? { border: "1px solid #dc3545" } : {}}
            value={jobName}
            onChange={handleJobNameChange}
            // placeholder={`Enter ${nameLabel} (letters, numbers, and spaces only)`}
             placeholder="Enter job name"
          />
          {jobNameError && (
            <div className="text-danger font-size-10">{jobNameError}</div>
          )}

          <h6 className="fw-sbold font-size-12 mt-3">{descriptionLabel}</h6>
          <textarea
            className="form-control highlighted-input doc-search  font-size-12 colorfor-placeholder styled-input"
            value={jobDescription}
            onChange={handleJobDescriptionChange}
             placeholder="Description"
            // placeholder={`Enter ${descriptionLabel} (max ${MAX_DESCRIPTION_LENGTH} characters)`}
            rows="3"
            style={{ height: "90px" }}
          ></textarea>
          <div className="d-flex justify-content-between">
            <small className="text-muted font-size-10">
              {`${jobDescription.length}/${MAX_DESCRIPTION_LENGTH} characters`}
            </small>
          </div>

          <div className="button-container mt-3">
            <button
              onClick={handleClose} 
              className="btn btn-closebtn custom-button"
            >
              Close
            </button>
            <button
              onClick={handleSave}
              className="btn btn-primary custom-button"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Edit;
